
<div class="app-frame jdm-app-background">
	<router-outlet></router-outlet>
</div>